import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SimpleBarScroll from "components/SimpleBar";
import ProductVariants from "pages/products/variants/ProductVariants";
import React from "react";

const ProductVariantsInDialog = ({ open, handleClose, product, variant }) => {
  return (
    <CustomDialog
      forceFullScreen={true}
      open={open}
      handleClose={handleClose}
      heading="Add product variant"
    >
      <Box sx={{ overflow: "hidden" }}>
        <SimpleBarScroll>
          <ProductVariants product_id={product.id} fullGrid={true} />
        </SimpleBarScroll>
      </Box>
    </CustomDialog>
  );
};

export default ProductVariantsInDialog;
